import axios from 'axios';

const ApiService = {
  init(baseURL) {
    axios.defaults.baseURL = `${baseURL}`;
    axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
    axios.defaults.headers.common['Content-Type'] = 'application/json';
    axios.defaults.headers.common.Accept = 'application/json';
    axios.defaults.timeout = 10000;

    // Interceptor
    /* prettier-ignore */
    axios.interceptors.response.use(
      response => response,
      // eslint-disable-next-line consistent-return
      async (error) => {
        console.log(error);

        return Promise.reject(error);
      },
    );
  },
  removeHeader() {
    axios.defaults.headers.common = {};
  },
  setHeader() {
    axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
    axios.defaults.headers.common['Content-Type'] = 'application/json';
    axios.defaults.headers.common.Accept = 'application/json';
  },

  get(resource, data) {
    if (data) return axios.get(resource, data);
    return axios.get(resource);
  },

  post(resource, data, header) {
    return axios.post(resource, data, header);
  },

  put(resource, data) {
    return axios.put(resource, data);
  },

  patch(resource, data) {
    return axios.patch(resource, data);
  },

  delete(resource, data) {
    if (data) return axios.delete(resource, { data });
    return axios.delete(resource, data);
  },
};

export default ApiService;
